import { useFetch } from "@/hooks/useFetch";
import { PageHeader } from "@/components/PageHeader";
import { DataTable } from "@/components/DataTable";
import { tanggalWaktu } from "@/lib/format";

export default function AuditLog() {
  const { data, loading } = useFetch("/audit-logs");
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Catatan seluruh aktivitas penting sistem" />
      {loading ? <div className="h-64 rounded-md bg-muted animate-pulse" /> : (
        <DataTable testId="audit" data={data || []} pageSize={15} columns={[
          { key: "at", label: "Waktu", render: (r) => tanggalWaktu(r.at) },
          { key: "user_name", label: "Pengguna", render: (r) => r.user_name || "-" },
          { key: "user_role", label: "Role" },
          { key: "action", label: "Aktivitas" },
          { key: "entity", label: "Entitas" },
          { key: "reason", label: "Alasan", render: (r) => r.reason || "-" },
        ]} />
      )}
    </div>
  );
}
